var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrityCruisesLogoXWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24L11.2184 11.47L1.06842 0H8.73435L15.0981 7.12797L21.4753 0H29.1613L18.9912 11.4768L30.1696 24H22.2966L15.1048 15.8664L7.89297 24H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrityCruisesLogoXWhite);
export default __webpack_public_path__ + "static/media/celebrity-cruises-logo-x-white.4bcca661c7f51cf3c6d4214b284d2eb6.svg";
export { ForwardRef as ReactComponent };